import React from 'react'
import { styled, alpha } from '@mui/material/styles'
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem'
import IndeterminateCheckBoxRoundedIcon from '@mui/icons-material/IndeterminateCheckBoxRounded'
import DisabledByDefaultRoundedIcon from '@mui/icons-material/DisabledByDefaultRounded'
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded'

const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
  [treeItemClasses.content]: {
    padding: theme.spacing(0.5, 1),
    margin: theme.spacing(0.2, 0)
  },
  [treeItemClasses.iconContainer]: {
    '& .close': {
      opacity: 0.3
    }
  },
  [treeItemClasses.groupTransition]: {
    marginLeft: 15,
    paddingLeft: 18,
    borderLeft: `2px solid ${alpha(theme.palette.text.primary, 0.4)}`
  }
}))

function ExpandIcon (props) {
  return <AddBoxRoundedIcon {...props} sx={{ opacity: 0.8 }} />
}

function CollapseIcon (props) {
  return <IndeterminateCheckBoxRoundedIcon {...props} sx={{ opacity: 0.8 }} />
}

function EndIcon (props) {
  return <DisabledByDefaultRoundedIcon {...props} sx={{ opacity: 0.3 }} />
}

export { CustomTreeItem, ExpandIcon, CollapseIcon, EndIcon }
